var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84961 4.07275V8.51841H6.29526",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1502 15.9276V11.4819H13.7046",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2906 7.7774C15.9148 6.71547 15.2761 5.76604 14.4342 5.0177C13.5922 4.26936 12.5744 3.7465 11.4757 3.49791C10.377 3.24931 9.23328 3.28309 8.15118 3.59609C7.06909 3.90909 6.08391 4.49111 5.28758 5.28783L1.84961 8.51834M18.1503 11.4821L14.7124 14.7126C13.916 15.5093 12.9309 16.0914 11.8488 16.4044C10.7667 16.7174 9.62292 16.7511 8.52423 16.5025C7.42555 16.254 6.40774 15.7311 5.56578 14.9828C4.72382 14.2344 4.08516 13.285 3.70938 12.2231",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.ae44f793a147ded64443334b1029ff7a.svg";
export { ForwardRef as ReactComponent };